// src/styles/theme.ts
export const theme = {
    colors: {
      primary: '#0070f3',
      secondary: '#1d1d1d',
    },
  };
  